import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Reels from "./pages/Reels";
import PortfolioPage from "./pages/PortfolioPage";
import ProjectDetails from "./pages/ProjectDetails";
import ProjectsOngoing from "./pages/projects/ProjectsOngoing";
import ProjectsCompleted from "./pages/projects/ProjectsCompleted";
import ProjectsUpcoming from "./pages/projects/ProjectsUpcoming";
import FloatingActions from "./components/ui/FloatingActions";

function App() {
  return (
    <Router>
      <Routes>
        {/* Home Page */}
        <Route path="/" element={<Home />} />
        <Route path="/reels" element={<Reels />} />
        <Route path="/portfolio" element={<PortfolioPage />} />
        <Route path="/project/:id" element={<ProjectDetails />} />
        <Route path="/projects/ongoing" element={<ProjectsOngoing />} />
        <Route path="/projects/completed" element={<ProjectsCompleted />} />
        <Route path="/projects/upcoming" element={<ProjectsUpcoming />} />
      </Routes>
      <FloatingActions />
    </Router>
  );
}

export default App;
